import React, { Component } from 'react';
import { Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';

class InstitutionalHolder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            holdingList: [],
            symbol: this.props.symbol,
            limit: this.props.limit
        };
    }

    custom_sort(a, b) {
        return b.shares - a.shares;
    }

    componentDidMount() {
        ApiService.getInstitutionalHolder(this.state.symbol)
            .then(result => {
                console.log('Institutional Holder', result);
                let filteredData = [];
                let length = this.state.limit === undefined ? 500 : this.state.limit;
                if (result.length > 0) {
                    result.sort(this.custom_sort);
                    length = result.length < length ? result.length : length;
                    for (var i = 0; i < length; i++) {
                        filteredData.push(result[i]);
                    }
                }
                this.setState({ holdingList: filteredData });
            })
            .catch((error) => {
                console.log(error);
            });

    }

    renderRow(listValue) {
        if (listValue !== undefined && listValue.holder !== undefined) {
            return (
                <tr key={listValue.holder}>
                    <td style={{ textAlign: 'right' }}>{listValue.shares}</td>
                    <td style={{ textAlign: 'left' }}>{listValue.holder}</td>
                    <td>{listValue.dateReported}</td>
                </tr>
            )
        }
    }

    render() {
        let tableRow;
        if (this.state.holdingList === null || this.state.holdingList.length <= 0) {
            tableRow = <tr><td></td><td>No Data</td><td></td></tr>
        } else {
            tableRow = this.state.holdingList.map(this.renderRow.bind(this));
        }
        console.log('holdingList', this.state.holdingList.length);
        let header = 'Institutional Holding';
        if (this.state.limit !== undefined) {
            header = <><Link to={'/institutionalHolder/' + this.state.symbol}>{header}</Link> <Link style={{ fontSize: "10px"}} to={'/institutionalHolder/' + this.state.symbol}>(More Details)</Link></>
        } else {
            header += ' - ' + this.state.symbol;
        }

        return (
            <div>
                {header}
                <Table striped bordered hover size="xs" style={{ fontSize: "10px" }}>
                    <thead>
                        <tr>
                            <th>Shares</th>
                            <th>Holder</th>
                            <th>Date
                                &nbsp;&nbsp;
                                <OverlayTrigger
                                    placement="left"
                                    overlay={<Tooltip id="button-tooltip-2" style={{ wordBreak: 'break-all' }}>
                                        Institutional ownership is the amount of a company's available stock owned by mutual or pension funds, insurance companies, investment firms, private foundations, endowments or other large entities that manage funds on behalf of others.<br /><br />
                                        Typically, institutional ownership is considered a good thing, but retail investors should understand what they are getting into when they buy a stock with high institutional ownership.
                                    </Tooltip>}>
                                    <i style={{ color: '#8A2BE2', fontSize: '15px' }} className={"fa fa-question-circle"}></i>
                                </OverlayTrigger>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRow}
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default InstitutionalHolder;
